resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function Select () {
  this.extends = [_Input, _ResponsiveLayout];
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.containerDiv = null;
  this.outerContainerDiv = null;
  this.inputContainerDiv = null;
  this.selectorNode = null;
  this.placeholderNode = null;
  this.ulNode = null;
  this.textLabel = null;
  this._expanded = false;
  this._focusedIndex = -1;
  this._currentSearchString = '';
  this._timer = null;
  this._busy = false;
  this._anyFocus = false;
  this.showFloatingLabel = false;
  this.floatingLabelText = '';

  this.placeholder = '';
  this.placeholderOutside = false;
  this.value = null;
  this.selectedIndex = 0;
  this.disabled = false;

  this.init = function () {
    if (this.node.tagName.toLowerCase() == 'select') {
      this.containerDiv = $("<div class='mogo-ui-select'></div>").insertBefore(this.node)[0];
      this.outerContainerDiv = $("<div class='outer-container'></div>");
      $(this.outerContainerDiv).appendTo(this.containerDiv);
      this.inputContainerDiv = $("<div class='input-container'></div>")[0];
      $(this.inputContainerDiv).appendTo(this.outerContainerDiv);
      this._setupFloatingLabel(); // https://mogofintech.atlassian.net/browse/ACCT-1143
      $(this.node).appendTo(this.inputContainerDiv);
      this.textLabel = $("<span class='textLabel'></span>").prependTo(this.inputContainerDiv);
      this.selectorNode = $("<a href='#' class='selector' aria-label='expand select'></a>").appendTo(
        this.inputContainerDiv
      );
      this.selectorNodeIcon = $("<span class='icon__svgarrowdown'>" +
                                "<svg viewBox='0 0 32 32'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#icon-arrowdown'></use>" +
                                '</svg></span>').appendTo(this.selectorNode);

      if ($(this.node).attr('placeholder') != null) {
        if (this.placeholder == '') this.placeholder = $(this.node).attr('placeholder');
        $(this.node).attr('placeholder', '');
      }
      if (this.placeholder != '') {
        if (this.placeholderOutside) {
          this.placeholderNode = $(
            "<label for='" + this.id + "'>" + this.placeholder + '</label>'
          )[0];
        } else {
          this.placeholderNode = $(
            "<label class='inner' for='" + this.id + "'>" + this.placeholder + '</label>'
          )[0];
        }
        $(this.placeholderNode).prependTo(this.containerDiv);
      }

      if (this.node.disabled || $(this.node).attr('readonly') == 'readonly') {
        this.disabled = true;
      }

      // Build select list
      this.ulNode = $("<ul tabindex='-1' class='horiz_scroll'></ul>")[0];
      if (this.placeholder != '') {
        $("<option disabled='disabled' value=''>" + this.placeholder + '</option>').prependTo(
          this.node
        );
      }
      var options = $('option', this.node);
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var li = null;
        if (option.disabled) {
          li = $("<li class='disabled' tabindex='-1'>" + $(option).text() + '</li>').appendTo(
            this.ulNode
          );
        } else {
          li = $("<li tabindex='-1'>" + $(option).text() + '</li>').appendTo(this.ulNode);
        }
        $(li).data('value', $(option).val());
        $(li).data('index', i);

        if (option.selected && $(option).attr('selected') != undefined) {
          this.value = $(option).val();
        }
      }
      $(this.ulNode).appendTo(this.outerContainerDiv);
    } else if (this.node.tagName.toLowerCase() == 'ul') {
      this.containerDiv = $("<div class='mogo-ui-select'></div>").insertBefore(this.node)[0];
      this.ulNode = this.node;
      this.outerContainerDiv = $("<div class='outer-container'></div>");
      $(this.outerContainerDiv).appendTo(this.containerDiv);
      this.inputContainerDiv = $("<div class='input-container'></div>")[0];
      $(this.inputContainerDiv).appendTo(this.outerContainerDiv);
      $(this.ulNode).appendTo(this.outerContainerDiv);
      this.selectorNode = $("<a href='#' class='selector'></a>").prependTo(
        this.inputContainerDiv
      );
      this.selectorNodeIcon = $("<span class='icon__svgarrowdown'>" +
                                "<svg viewBox='0 0 32 32'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#icon-arrowdown'></use>" +
                                '</svg></span>').appendTo(this.selectorNode);

      this.textLabel = $("<span class='textLabel'></span>").prependTo(this.inputContainerDiv);

      // Select
      this.node = $('<select></select>')[0];
      $(this.node).addClass('no-custom');
      var attributes = this.ulNode.attributes;
      for (var i = attributes.length - 1; i >= 0; i--) {
        var attribute = attributes[i];
        if (attribute.name != 'class' && attribute.name != 'style') {
          $(this.node).attr(attribute.name, attribute.value);
          $(this.ulNode).removeAttr(attribute.name);
        }
      }
      $(this.ulNode).attr('tabindex', '-1');
      $(this.ulNode).addClass('horiz_scroll');
      $(this.node).appendTo(this.inputContainerDiv);

      if ($(this.node).attr('placeholder') != null) {
        if (this.placeholder == '') this.placeholder = $(this.node).attr('placeholder');
        $(this.node).attr('placeholder', '');
      }
      if (this.placeholder != '') {
        if (this.placeholderOutside) {
          this.placeholderNode = $(
            "<label for='" + this.id + "'>" + this.placeholder + '</label>'
          )[0];
        } else {
          this.placeholderNode = $(
            "<label class='inner' for='" + this.id + "'>" + this.placeholder + '</label>'
          )[0];
        }
        $(this.placeholderNode).prependTo(this.containerDiv);
        $("<li disabled='disabled'>" + this.placeholder + '</li>').prependTo(this.ulNode);
      }

      // Options
      var liItems = $('li', this.ulNode);
      for (var i = 0; i < liItems.length; i++) {
        var li = liItems[i];
        var option = $('<option>' + $(li).text() + '</option>')[0];
        var value = $(li).attr('value') ? $(li).attr('value') : '';
        $(option).attr('value', value);
        $(li).data('value', value);
        $(li).data('index', i);
        $(li).removeAttr('value');
        $(li).attr('tabindex', '-1');
        if ($(li).attr('disabled') && $(li).attr('disabled') == 'disabled') {
          $(li).removeAttr('disabled');
          $(li).addClass('disabled');

          $(option).attr('disabled', 'disabled');
        }
        if ($(li).attr('selected') && $(li).attr('selected') == 'selected') {
          $(li).removeAttr('selected');
          $(li).addClass('selected');
          $(option).attr('selected', 'selected');
        }
        $(option).appendTo(this.node);
      }
    }

    // Firefox skips selects when tabbing if tabindex is -1 [PT #151017752]
    if ($('html.touch').length == 0 && navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {
      $(this.node).attr('tabindex', -1);
    }

    if (this.disabled) {
      $(this.containerDiv).addClass('disabled');
    }

    // if (this.node.selectedIndex != 0)
    //    this.selectedIndex = this.node.selectedIndex;

    // Set/get value, selectedIndex
    if (this.value == null) {
      var li = $('li', this.ulNode)[this.selectedIndex];
      this.value = $(li).data('value');
    } else {
      var lis = $('li', this.ulNode);
      for (var i = 0; i < lis.length; i++) {
        if ($(lis[i]).data('value') == this.value) {
          this.selectedIndex = i;
        }
      }
    }
    this.setSelectedIndex(this.selectedIndex);

    // Connections
    $(this.selectorNode).on('click', $.proxy(this._onToggleSelect, this));
    $(this.selectorNode).on('focus', $.proxy(this._showSelect, this));
    $(this.selectorNode).on('blur', $.proxy(this._checkBlur, this));
    $(document).on('click', $.proxy(this._onClickDocument, this));
    $('li', this.ulNode).on('click', $.proxy(this._onClickItem, this));
    $('li', this.ulNode).on('mouseover', $.proxy(this._onMouseOverItem, this));
    $('li', this.ulNode).on('keydown', $.proxy(this._onKeyDownItem, this));
    $('li', this.ulNode).on('blur', $.proxy(this._checkBlur, this));
    $(this.ulNode).on('keydown', $.proxy(this._onKeyDownUl, this));
    $(this.ulNode).on('keypress', $.proxy(this._onKeyPressUl, this));
    $(this.node).on('change', $.proxy(this._onChangeSelectNode, this));
    // if the select is focused in Firefox, move focus to the custom accessible element
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
      $(this.node).on('focus', $.proxy(this._showSelect, this));
    }
    this.registerResponsiveFunction($.proxy(this._onWindowResize, this), null, null);
    $(this.node).css('display', 'block');

    this._super();
  };

  this.initAllReady = function () {};

  // https://mogofintech.atlassian.net/browse/ACCT-1143
  this._setupFloatingLabel = function () {
    // Select element needs [data-mogo-ui-show-label] and [data-mogo-ui-label-text] attr's
    if (this.showFloatingLabel && this.floatingLabelText !== '') {
      this.containerDiv.addClass('mogo-ui-select-floating-label');
      $(this.containerDiv)
        .find('.input-container')
        .append('<label class="floating-label">' + this.floatingLabelText + '</label>');
    }
  };

  this.setSelectedIndex = function (index) {
    if (index >= $('li', this.ulNode).length) return;

    this.selectedIndex = index;
    $('li.selected', this.ulNode).removeClass('selected');
    $(this.textLabel).html($($('li', this.ulNode)[index]).html());

    if (index > 0) $(this.textLabel).addClass('selected-item');
    else $(this.textLabel).removeClass('selected-item');

    $($('li', this.ulNode)[index]).addClass('selected');
    this.node.selectedIndex = index;
    this.value = $(this.node).val();
  };

  this.val = function (value) {
    if (arguments.length == 1 && arguments[0] === '') {
      this.setSelectedIndex(0);
    } else {
      if (value != null && value != '') {
        var options = $('option', this.node);
        for (var i = 0; i < options.length; i++) {
          if (options[i].value == value) {
            this.setSelectedIndex(i);
          }
        }
      } else {
        return $(this.node).val();
      }
    }
  };

  this.addOption = function (text, value, disabled, noReindex, config) {
    var li;
    var option;
    var styles = '';
    if (config && config.styles) {
      styles = styles + config.styles;
    }
    if (disabled) {
      li = $("<li class='disabled " + styles + "'>" + text + '</li>');
      option = $(
        "<option class='" +
          styles +
          "' value='" +
          value +
          "' disabled='disabled'>" +
          text +
          '</option>'
      );
    } else {
      li = $("<li class='" + styles + "' tabindex='-1'>" + text + '</li>');
      option = $("<option class='" + styles + "' value='" + value + "'>" + text + '</option>');
    }
    $(li).data('value', value);
    $(li).appendTo(this.ulNode);
    $(option).appendTo(this.node);

    $(li).on('click', $.proxy(this._onClickItem, this));
    $(li).on('mouseover', $.proxy(this._onMouseOverItem, this));
    $(li).on('keydown', $.proxy(this._onKeyDownItem, this));
    $(li).on('blur', $.proxy(this._checkBlur, this));

    // Reindex
    if (noReindex) return;

    var liList = $('li', this.ulNode);
    for (var i = 0; i < liList.length; i++) $(liList[i]).data('index', i);
  };

  this._onToggleSelect = function (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
    if (this._busy) return;

    if (this._expanded) {
      this._hideSelect();
    } else {
      this._showSelect();
    }
  };

  this._onChangeSelectNode = function (evt) {
    this.setSelectedIndex(this.node.selectedIndex);
  };

  this._showSelect = function (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
    if (this._expanded || this._busy || this.disabled) return;

    this._busy = true;
    this._focusedIndex = this.selectedIndex;
    this._resize();
    if (this._anyFocus == false) {
      this._anyFocus = true;
      $(this.containerDiv).trigger('enter');
    }
    if ($(this.node).parent('.mogo-ui-dialog')) {
      // KL: This is quick fix, should be re-done
      var dialog = $(this.node).parent('.mogo-ui-dialog')[0];
      $('.dialog_container', dialog).css('overflow', 'visible');
      $('.dialog_container_content', dialog).css('overflow', 'visible');
    }
    $(this.containerDiv).addClass('expanded');
    $(this.ulNode).fadeIn({
      duration: 175,
      complete: $.proxy(function () {
        this._busy = false;
      }, this)
    });
    this._setFocus($('li', this.ulNode)[this._focusedIndex]);
    this._expanded = true;
  };

  this._hideSelect = function (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
    if (!this._expanded || this._busy) return;

    this._busy = true;
    // $("body").css("top", "0");
    // $(window).scrollTop(this.currentScrollTop);
    // $("body").removeClass("disableScroll");
    if ($(this.node).parent('.mogo-ui-dialog')) {
      // KL: This is quick fix, should be re-done
      var dialog = $(this.node).parent('.mogo-ui-dialog')[0];
      $('.dialog_container', dialog).css('overflow', 'hidden');
      $('.dialog_container_content', dialog).css('overflow', 'auto');
    }
    $(this.containerDiv).removeClass('expanded');
    $(this.ulNode).fadeOut({
      duration: 175,
      complete: $.proxy(function () {
        this._busy = false;
      }, this)
    });
    this.selectorNode.focus();
    this._focusedIndex = -1;
    this._expanded = false;
  };

  this._onKeyDownItem = function (evt) {
    if (evt.which == $.ui.keyCode.ENTER) {
      this._onClickItem(evt);
    }
  };

  this._onKeyDownUl = function (evt) {
    if (evt.which == $.ui.keyCode.ESCAPE) {
      this._hideSelect();
    } else if (evt.which == $.ui.keyCode.UP) {
      var liNodes = $('li', this.ulNode);
      var liNode;
      if (this._focusedIndex != -1) {
        liNode = liNodes[this._focusedIndex - 1];
      }
      var index = this._focusedIndex - 1;
      while (liNode != undefined && $(liNode).hasClass('disabled')) {
        index--;
        liNode = liNodes[index];
      }
      if (liNode != undefined) {
        this._setFocus(liNode);
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();
    } else if (evt.which == $.ui.keyCode.DOWN) {
      var liNodes = $('li', this.ulNode);
      var liNode;
      if (this._focusedIndex == -1) {
        liNode = liNodes[0];
      } else {
        liNode = liNodes[this._focusedIndex + 1];
      }
      var index = this._focusedIndex + 1;
      while (liNode != undefined && $(liNode).hasClass('disabled')) {
        index++;
        liNode = liNodes[index];
      }
      if (liNode != undefined) {
        this._setFocus(liNode);
      }

      evt.preventDefault();
      evt.stopImmediatePropagation();
    } else if (evt.which == $.ui.keyCode.TAB) {
      this._hideSelect();
      this._anyFocus = false;
      // $(this.containerDiv).trigger("leave");
    }
  };

  this._onKeyPressUl = function (evt) {
    this._currentSearchString = this._currentSearchString + String.fromCharCode(evt.which);
    var liList = $('li', this.ulNode);
    var found = false;
    for (var i = this._focusedIndex + 1; i < liList.length; i++) {
      var li = liList[i];
      if ($(li).text().toLowerCase().indexOf(this._currentSearchString.toLowerCase()) == 0) {
        this._setFocus(li);
        found = true;
        break;
      }
    }
    if (!found) {
      for (var i = 0; i < this._focusedIndex; i++) {
        var li = liList[i];
        if ($(li).text().toLowerCase().indexOf(this._currentSearchString.toLowerCase()) == 0) {
          this._setFocus(li);
          break;
        }
      }
    }
    clearTimeout(this._timer);
    this._timer = setTimeout($.proxy(this._clearSearchString, this), 1000);

    evt.preventDefault();
    evt.stopImmediatePropagation();
  };

  this._onMouseOverItem = function (evt) {
    if (!$(evt.currentTarget).hasClass('disabled')) this._setFocus(evt.currentTarget);
  };

  this._onClickItem = function (evt) {
    if (!$(evt.currentTarget).hasClass('disabled')) {
      if ($(evt.currentTarget).data('value') != this.val()) {
        this.val($(evt.currentTarget).data('value'));
        $(this.node).trigger('change');
      }
      this._hideSelect();
    }
    if (evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }
  };

  this._onClickDocument = function (evt) {
    if (this._expanded) {
      this._hideSelect();
      this._checkActiveElement();
    }
  };

  this._onWindowResize = function () {
    if (this._expanded) this._resize();
  };

  this._resize = function () {
    $(this.ulNode).removeClass('inverse');
    $(this.ulNode).css('top', '');
    $(this.ulNode).css('height', '');
    var ulHeight = $(this.ulNode).outerHeight();
    var outerContainerDivHeight = $(this.outerContainerDiv).outerHeight();
    var componentTopLocation = $(this.outerContainerDiv).offset().top - $(window).scrollTop();
    var componentBottomLocation = componentTopLocation + outerContainerDivHeight;
    var windowHeight = $(window).outerHeight();
    var headerHeight = 0;
    if ($('#portal_nav').length > 0) headerHeight = $('#portal_nav').outerHeight();
    else if ($('#marketing_nav').length > 0) headerHeight = $('#marketing_nav').outerHeight();
    var bottomHeightAllowed = windowHeight - componentBottomLocation - 20; // 20px for padding
    var topHeightAllowed = componentTopLocation - headerHeight;
    if (ulHeight > bottomHeightAllowed - 20 && ulHeight <= topHeightAllowed - 20) {
      // 20px for padding
      $(this.ulNode).addClass('inverse');
      $(this.ulNode).css('top', -ulHeight + 'px');
    } else if (ulHeight > bottomHeightAllowed - 20 && ulHeight > topHeightAllowed - 20) {
      // 20px for padding
      if (bottomHeightAllowed > topHeightAllowed) {
        $(this.ulNode).css('height', Math.floor(bottomHeightAllowed - 20) + 'px');
      } else {
        $(this.ulNode).addClass('inverse');
        var h = Math.floor(topHeightAllowed - 20);
        $(this.ulNode).css('height', h + 'px');
        $(this.ulNode).css('top', -h + 1 + 'px');
      }
    }
  };

  this._setFocus = function (li) {
    li.focus();
    this._focusedIndex = $(li).data('index');
  };

  this._clearSearchString = function () {
    this._currentSearchString = '';
  };

  this._checkBlur = function () {
    setTimeout($.proxy(this._checkActiveElement, this), 50);
  };

  this._checkActiveElement = function () {
    if (!$.contains(this.containerDiv, document.activeElement)) {
      $(this.containerDiv).trigger('leave');
      if (this._expanded) {
        this._busy = true;
        $(this.containerDiv).removeClass('expanded');
        $(this.ulNode).fadeOut({
          duration: 175,
          complete: $.proxy(function () {
            this._busy = false;
          }, this)
        });
        this._expanded = false;
      }
      this._focusedIndex = -1;
      this._anyFocus = false;
    }
  };
}
